import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';

import {
  selectCustomerData,
  selectDisposibleAccounts,
  selectIsPremiumAccount,
  selectOwnAccounts,
  selectUser,
} from '../../state/user/selectors';
import getAccountType from '../../utils/getAccountType';
import * as UserActions from '../../actions/user';

const AccountRows = ({ accounts }) => {
  const dispatch = useDispatch();
  const isPremiumAccount = useSelector(selectIsPremiumAccount);

  if (accounts.isEmpty()) return null;

  return (
    <table>
      <caption>Mine kontoer</caption>
      <thead>
        <tr>
          <th>Navn</th>
          <th>Kontotype</th>
          {!isPremiumAccount && <th>Tjenester</th>}
        </tr>
      </thead>
      <tbody>
        {accounts.map((account, i) => (
          <tr
            className={classNames({ selected: account.get('isSelected') })}
            key={i}
          >
            <td className="text">
              {account.get('isSelected') ? (
                account.get('fullName')
              ) : (
                <button
                  className="unstyle-button"
                  onClick={() => {
                    dispatch(
                      UserActions.setActiveAccount(account.get('customerId')),
                    );
                  }}
                >
                  {account.get('fullName')}
                </button>
              )}
            </td>
            <td className="text">{getAccountType(account)}</td>
            {!isPremiumAccount && (
              <td className="services" data-test-id="services-row">
                <Link
                  to={`/account/${account.get('vpsAccountNo')}`}
                  className="text-center"
                >
                  <i className="fa fa-briefcase" /> Vis
                </Link>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const AccountDetails = ({ endTakeover, hideExpand, handleLogOut }) => {
  const user = useSelector(selectUser);
  const customer = useSelector(selectCustomerData);
  const ownAccounts = useSelector(selectOwnAccounts);
  const disposableAccounts = useSelector(selectDisposibleAccounts);
  const isPremiumAccount = useSelector(selectIsPremiumAccount);
  AccountDetails.handleClickOutside = () => hideExpand();

  if (!customer) return;

  return (
    <span className="Expando" data-test-id="AccountDetails">
      <AccountRows accounts={ownAccounts} />
      <AccountRows accounts={disposableAccounts} />
      <div className="links" onClick={hideExpand}>
        {!isPremiumAccount && (
          <Link to="/alerts" data-test-id="showAlarm">
            <i className="fa fa-bell" /> Vis alarmer
          </Link>
        )}
        <button className="unstyle-button" onClick={handleLogOut}>
          Logg ut <i className="fa fa-sign-out" />
        </button>
      </div>
      {user.get('takeover') && (
        <div className="takeover-button">
          <button
            onClick={() => {
              endTakeover(customer.get('customerNumber'));
            }}
          >
            End takeover session
          </button>
        </div>
      )}
    </span>
  );
};

// Required for onCLickOutside.
AccountDetails.prototype = {};

const clickOutsideConfig = {
  handleClickOutside: () => AccountDetails.handleClickOutside,
};

export default onClickOutside(AccountDetails, clickOutsideConfig);
